import {Route, Routes} from "react-router-dom";
import {IRoute, routes} from "../../Data/SidebarData";
import React from "react";

const SBRoutes = () => {

    const routedContent = (
        <Routes>
            {routes.map((item: IRoute) => (
                <Route key={item.key} path={item.key} element={item.reactElement}/>
            ))}
        </Routes>
    );

    return (
        <div style={{height: '100%', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'}}>
            {routedContent}
        </div>
    );
}

export default SBRoutes;
